// Module
var code = "<div class=\"node-graph-viewer graph\" ng-class=\"{ 'graph-{{ ctrl.name }}': true }\"> </div> ";
// Exports
export default code;